function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagLevel02 = function SvgFlagLevel02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 0c5.5 0 10 4.5 10 10s-4.5 10-10 10S0 15.5 0 10 4.5 0 10 0z",
    style: {
      fill: "#e4bc07"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5.8c0-.3-.3-.6-.6-.6s-.6.3-.6.6v8.4c0 .3.3.6.6.6s.6-.3.6-.6v-3c.4.3.9.6 1.6.6.6 0 1.1-.3 1.7-.6.6-.3 1.1-.6 1.7-.6 1.4 0 2.2 1.2 2.2 1.2V7s-.8-1.2-2.2-1.2c-.6 0-1.1.3-1.7.6-.6.3-1.1.6-1.7.6-.7 0-1.2-.3-1.6-.6v-.6z",
    style: {
      fill: "#061b09"
    }
  }));
};
export default SvgFlagLevel02;